export default function Menu(theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 10,
          boxShadow: theme.customShadows.dropdown,
          border: `1px solid ${theme.palette.grey[200]}`,
          marginTop: theme.spacing(0.5),
        },
        list: { padding: theme.spacing(0.5) },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontSize: theme.typography.pxToRem(13.5),
          padding: theme.spacing(0.75, 1.25),
          minHeight: 36,
          '&:hover': { backgroundColor: theme.palette.grey[100] },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: 10,
          boxShadow: theme.customShadows.dropdown,
          border: `1px solid ${theme.palette.grey[200]}`,
        },
      },
    },
  };
}
